import Vue from 'vue';
import Vuelidate from 'vuelidate';
import VueAnalytics from 'vue-analytics';
import 'normalize.css';
import App from './App';
import registerVuetify from './vuetify';
import {
	httpRequestInterceptor,
	httpResponseInterceptor,
	httpResponseSuccessInterceptor,
} from './http/index';
import registerAxios from './axios';
import vueRouter from './router';
import globalMixin from './mixins/global';
import registerFilters from './filters/global';
import './global-components';
import store from './store';

Vue.use(Vuelidate);
Vue.use(VueAnalytics, {
	id: 'UA-XXXXXXX-1',
	autoTracking: {
		screenview: true,
	},
	disableScriptLoader: true,
	sendHitTask: window.location.hostname === 'acl.japisale.com',
});

const router = vueRouter(Vue);
registerFilters(Vue);
registerVuetify(Vue);
registerAxios(Vue);
Vue.prototype.$imageUrl = process.env.S3_IMAGES_URL;
Vue.prototype.$projectId = 0;
Vue.config.productionTip = false;
Vue.mixin(globalMixin);

async function created() {
	this.$http.interceptors.request.use(this.httpRequestInterceptor);
	this.$http.interceptors.response.use(
		this.httpResponseSuccessInterceptor,
		this.httpResponseInterceptor,
	);
	this.$httpMock.interceptors.request.use(this.httpRequestInterceptor);
	this.$httpMock.interceptors.response.use(
		this.httpResponseSuccessInterceptor,
		this.httpResponseInterceptor,
	);
}

/* eslint-disable no-new */
new Vue({
	created,
	el: '#app',
	methods: {
		httpRequestInterceptor,
		httpResponseInterceptor,
		httpResponseSuccessInterceptor,
	},
	router,
	render: h => h(App),
	store,
});



// WEBPACK FOOTER //
// ./src/main.js